import * as React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LDUser } from 'launchdarkly-js-sdk-common';
import { observer } from 'mobx-react-lite';
import { useMst } from '../models/stores/Root';
import UtilityService from '../services/UtilityService';

const LaunchDarklyProvider: React.FC = observer(({ children }) => {
  const { configuration } = useMst();

  const userInfo: LDUser | undefined = React.useMemo(
    () =>
      configuration.storeId
        ? {
            name: UtilityService.getBaseUrl(window.location.origin),
            key: configuration.storeId,
          }
        : undefined,
    [configuration.storeId]
  );

  return (
    <LDProvider
      clientSideID={process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID as string}
      deferInitialization
      user={userInfo}
    >
      {children}
    </LDProvider>
  );
});

export default LaunchDarklyProvider;
